module.exports = "/images/apple-touch-icon.png?3322ccc";


//////////////////
// WEBPACK FOOTER
// ./resources/img/favicon/apple-touch-icon.png
// module id = 22
// module chunks = 0